import { useDispatch, useSelector } from "react-redux";
import {
  CarsAvailabilityActions,
  type CarSortOptionEnum,
  useCarListSortOptions,
  CarsAvailabilitySelectors,
} from "@apac/components/cars";

export const useCarListSort = () => {
  const dispatch = useDispatch();

  const selectedSort = useSelector(CarsAvailabilitySelectors.getSort);

  const handleSortChange = (value: string) => {
    dispatch(CarsAvailabilityActions.setSort(value as CarSortOptionEnum));
  };

  const sortOptions = useCarListSortOptions();

  const getSortLabelKey = (sortOption: CarSortOptionEnum): string =>
    sortOptions.find((option) => option.value === sortOption)?.shortLabel ?? "";

  return {
    context: {
      sortOptions,
      selectedSort,
    },
    handlers: {
      getSortLabelKey,
      handleSortChange,
    },
  };
};
